/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * An expressions for filtering alerts
 * @export
 * @interface InternalApiAlertFilterExpression
 */
export interface InternalApiAlertFilterExpression {
    /**
     * 
     * @type {InternalApiAlertFilterExpressionTargetEnum}
     * @memberof InternalApiAlertFilterExpression
     */
    target: InternalApiAlertFilterExpressionTargetEnum;
    /**
     * 
     * @type {string}
     * @memberof InternalApiAlertFilterExpression
     */
    field: string;
    /**
     * 
     * @type {string}
     * @memberof InternalApiAlertFilterExpression
     */
    value: string;
    /**
     * 
     * @type {InternalApiAlertFilterExpressionFieldTypeEnum}
     * @memberof InternalApiAlertFilterExpression
     */
    fieldType: InternalApiAlertFilterExpressionFieldTypeEnum;
    /**
     * 
     * @type {InternalApiAlertFilterExpressionOperationEnum}
     * @memberof InternalApiAlertFilterExpression
     */
    operation: InternalApiAlertFilterExpressionOperationEnum;
}

/**
* @export
* @enum {string}
*/
export enum InternalApiAlertFilterExpressionTargetEnum {
    PERSON = 'PERSON',
    TRANSACTION = 'TRANSACTION',
    ALERT = 'ALERT'
}
/**
* @export
* @enum {string}
*/
export enum InternalApiAlertFilterExpressionFieldTypeEnum {
    STRING = 'STRING',
    STRING_LIST = 'STRING_LIST',
    NUMBER = 'NUMBER',
    TIMESTAMP = 'TIMESTAMP'
}
/**
* @export
* @enum {string}
*/
export enum InternalApiAlertFilterExpressionOperationEnum {
    EQUALS = 'EQUALS',
    EQUALS_ONE_OF = 'EQUALS_ONE_OF',
    GREATER_THAN = 'GREATER_THAN',
    LESS_THAN = 'LESS_THAN',
    PARTLY_MATCHES = 'PARTLY_MATCHES',
    NOT_EQUALS = 'NOT_EQUALS',
    NOT_EQUALS_ONE_OF = 'NOT_EQUALS_ONE_OF',
    NO_PARTIAL_MATCH = 'NO_PARTIAL_MATCH'
}


/**
 * Check if a given object implements the InternalApiAlertFilterExpression interface.
 */
export function instanceOfInternalApiAlertFilterExpression(value: object): value is InternalApiAlertFilterExpression {
    if (!('target' in value) || value['target'] === undefined) return false;
    if (!('field' in value) || value['field'] === undefined) return false;
    if (!('value' in value) || value['value'] === undefined) return false;
    if (!('fieldType' in value) || value['fieldType'] === undefined) return false;
    if (!('operation' in value) || value['operation'] === undefined) return false;
    return true;
}

export function InternalApiAlertFilterExpressionFromJSON(json: any): InternalApiAlertFilterExpression {
    return InternalApiAlertFilterExpressionFromJSONTyped(json, false);
}

export function InternalApiAlertFilterExpressionFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiAlertFilterExpression {
    if (json == null) {
        return json;
    }
    return {
        
        'target': json['target'],
        'field': json['field'],
        'value': json['value'],
        'fieldType': json['fieldType'],
        'operation': json['operation'],
    };
}

export function InternalApiAlertFilterExpressionToJSON(json: any): InternalApiAlertFilterExpression {
    return InternalApiAlertFilterExpressionToJSONTyped(json, false);
}

export function InternalApiAlertFilterExpressionToJSONTyped(value?: InternalApiAlertFilterExpression | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'target': value['target'],
        'field': value['field'],
        'value': value['value'],
        'fieldType': value['fieldType'],
        'operation': value['operation'],
    };
}

